// Default State
const state = {
	needsBasketNavRefresh: false,
    needsTotalsRefresh: false,
}
// Module Getters
const getters = {
	getBasketNavRefreshStatus: state => {
		return state.needsBasketNavRefresh;
	},
    getTotalsRefreshStatus: state => {
        return state.needsTotalsRefresh;
    },
}

// Module Actions
const actions = {
    refreshBasketNav({ commit }) {
        commit('updateBasketNavRefreshStatus', true);
        setTimeout(() => {
            commit('updateBasketNavRefreshStatus', false);
        }, 100);
    }
}

// Module Mutations
const mutations = {
	updateBasketNavRefreshStatus(state, payload) {
		state.needsBasketNavRefresh = payload;
	},
    updateTotalsRefreshStatus ( state, payload ) {
        state.needsTotalsRefresh = payload;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
